import React from 'react';
import AdminDashboard from './AdminDashboard';
import DeveloperDashboard from './DeveloperDashboard';
import AgentDashboard from './AgentDashboard';
import WorkspaceRoleFallback from './WorkspaceRoleFallback';

const ADMIN_ROLES = new Set(['company_admin']);
const DEVELOPER_ROLES = new Set(['developer']);
const AGENT_ROLES = new Set(['agent', 'trainee', 'manager']);

/**
 * Picks the role-specific overview workspace inside the main dashboard shell.
 */
export default function RoleWorkspace({
  userData,
  roleLoading,
  welcomeName,
  onOpenTeam,
  onOpenTickets,
  onOpenMonitoring,
}) {
  const role = userData?.role;

  if (roleLoading) {
    return <WorkspaceRoleFallback loading />;
  }

  if (!role) {
    return <WorkspaceRoleFallback />;
  }

  if (ADMIN_ROLES.has(role)) {
    return (
      <AdminDashboard
        welcomeName={welcomeName}
        onOpenTeam={onOpenTeam}
        onOpenTickets={onOpenTickets}
      />
    );
  }

  if (DEVELOPER_ROLES.has(role)) {
    return (
      <DeveloperDashboard
        welcomeName={welcomeName}
        onOpenMonitoring={onOpenMonitoring}
      />
    );
  }

  if (AGENT_ROLES.has(role)) {
    return (
      <AgentDashboard
        welcomeName={welcomeName}
        onOpenTickets={onOpenTickets}
      />
    );
  }

  return <WorkspaceRoleFallback role={role} />;
}
